/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";
import { Button as MdButton } from "@rmwc/button";
import "@rmwc/button/styles";
import CircularProgress from "../../Spinner/CircularProgress";
import Svg from "../../Image/Svg";
import useTheme from "../../../commons/hooks/use-theme";
import {
  handleClick,
  handleMouseLeave,
  handleMouseUp,
  handleMouseDown,
  handleTouchEnd,
  handleTouchStart,
} from "./commons/button-commons";
import { ButtonProps } from "./commons/button-props";

const Button: FC<ButtonProps> = (props) => {
  const {
    children,
    raised = true,
    danger,
    disabled = false,
    icon,
    loading,
    fullSize = false,
    iconSize = "small",
    className,
    margin,
    backgroundColor,
    color,
    outlined,
    onClick,
    dense,
    onTouchEnd,
    onTouchStart,
    onMouseUp,
    onMouseLeave,
    onMouseDown,
  } = props;

  const theme = useTheme();

  const styles = {
    buttonWrapper: css`
      margin: ${margin};

      :disabled {
        color: ${theme.material.textHintOnBackground};
      }

      letter-spacing: normal;
      width: ${fullSize ? "100%" : "auto"};
      height: 40px;

      .rmwc-circular-progress {
        color: ${theme.material.onPrimary};
      }
    `,
  };

  let buttonIcon = icon && (
    <Svg size={iconSize} icon={icon} color={raised ? theme.material.onPrimary : theme.material.primary} />
  );

  if (loading) buttonIcon = <CircularProgress size={iconSize} />;

  return (
    <MdButton
      icon={buttonIcon}
      onClick={() => handleClick(onClick)}
      onTouchEnd={() => handleTouchEnd(onTouchEnd)}
      onTouchStart={(e) => handleTouchStart(onTouchStart, e)}
      onMouseDown={(e) => handleMouseDown(onMouseDown, e)}
      onMouseUp={() => handleMouseUp(onMouseUp)}
      onMouseLeave={() => handleMouseLeave(onMouseLeave)}
      raised={raised}
      outlined={outlined}
      disabled={disabled}
      danger={danger}
      css={styles.buttonWrapper}
      className={className}
      style={{ backgroundColor, color }}
      dense={dense}
    >
      {children}
    </MdButton>
  );
};
export default Button;
